import * as clipboard from "@/services/clipboard.js"

import * as sentryReporter from "@/services/sentryReporter.js"

export const methods = {
  ABORTED: "aborted",
  NAVIGATOR: "navigator",
  CLIPBOARD: "clipboard"
}

export const share = async function (url, text) {
  if (navigator.share) {
    try {
      await navigator.share({ url, text })
    } catch (err) {
      if (err.name !== "AbortError") {
        sentryReporter.reportError(err)
      }
      return methods.ABORTED
    }

    return methods.NAVIGATOR
  }

  await clipboard.write(url)
  return methods.CLIPBOARD
}
